import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Ids from '@utils/ids';
import { setStorage } from '@utils/localStorage';
import { failToast } from '@utils/toast';
import request from '@utils/axiosWrapper';
import styles from './ProtocolModal.module.scss';

import { RootState } from '../../store';

const wmPoiId = Ids.getWmPoiId();
const cacheKey = `compensateProtocolSignedFor${wmPoiId}`;

const { useCallback } = React;

/** 非SLA商家7折赔付留痕 */
const ProtocolModal: React.FC<{ modalVisible: boolean; closeModal: () => void }> = ({
    modalVisible,
    closeModal,
}) => {
    const confirmHandler = useCallback(() => {
        request
            .postAsFormSubmit('/api/poi/w/poi/compensate/protocol', { signStatus: 1 })
            .then(() => {
                setStorage(cacheKey, 'true');
                closeModal();
            })
            .catch(e => {
                failToast(e.message);
                closeModal();
            });
    }, []);

    return modalVisible ? (
        <div className={`${styles.protocolDialog} `}>
            <div className={styles.header}>
                <img alt="美团外卖商家中心" src="/static/imgs/logo.webp" />
            </div>
            <div>
                <div className={styles.content}>
                    {/* <!--餐损赔付标准说明 签署模式--> */}
                    <div className={styles.protocol}>
                        <div className={styles.protocolTitle}>
                            <h4>餐损赔付标准说明</h4>
                        </div>
                        <div className={styles.protocolCon}>
                            <h5>致 美团外卖平台商户（下称“商户”）</h5>
                            <div>
                                <p>
                                    1.
                                    鉴于商户与美团外卖平台签署有《平台商户入驻服务框架协议》及附件《配送服务合同》（下统称“主合同”）并在履约中。依据主合同约定，美团外卖平台提供的配送环节原因导致用户取消订单给商户造成经济损失的，美团外卖平台向商户赔付经济损失。具体赔付规则为：订单赔付金额=
                                    （菜品原价＋餐盒费－商家活动款－平台使用费-青山公益（如涉及））*70%。
                                </p>
                                <p>
                                    2.
                                    本说明中有关美团外卖平台提供的配送环节原因，包括：配送员丢餐、撒餐、少餐、配送员通知无法配送、配送超时、送错地址、配送员服务态度差、配送员接单不配送、快送运力不足、配送系统故障。
                                </p>
                                <p>
                                    3.
                                    本说明仅适用于由美团外卖平台提供快送服务的商户订单。如商户已选定配送服务2.0，则具体赔付规则以商户所签署的相应文件约定为准。
                                </p>
                                <p>
                                    4.
                                    商户需要保证在美团外卖平台上的全部订单均为真实有效订单，并遵守美团外卖违规作弊管理规范，如商户出现包括但不限于：刷单、作弊等虚假交易、伪造餐损信息骗取平台餐损赔付等情形，美团外卖平台有权利不进行赔付，如美团外卖平台因此遭受损失的，商户应予赔偿。美团外卖平台有权直接从应付商户的相应款项中予以扣除。如商户构成违法犯罪的，则美团外卖平台有权移交公安、司法机关处理。
                                </p>
                                <p>
                                    5.
                                    本说明为主合同的补充内容，具有同等法律效力。本说明自上线之日起即生效。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.footer} `}>
                    <button type="button" className={`${styles.btn} `} onClick={confirmHandler}>
                        同意以上协议
                    </button>
                    <span className={styles.ignore} onClick={closeModal}>
                        跳过，下次再签
                    </span>
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        modalVisible: state.shellCommon.compensateProtocolModalVisibility,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        closeModal: () =>
            dispatch({
                type: 'shellCommon/changeCompensateProtocolModalVisibility',
                payload: false,
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtocolModal);
